import { PumpAsset, ValveAsset } from 'src/types/assets';

type UsePumpStateProps = {
  asset?: PumpAsset | ValveAsset;
};

export const usePumpStateAndMode = ({ asset }: UsePumpStateProps) => {
  const stateFromRest = asset?.activeState;
  const modeFromRest = asset?.activeMode?.mode?.label;
  const activeState = stateFromRest?.state?.label;
  const isOperational = stateFromRest?.state?.isOperational;

  const isRunning = Boolean(isOperational);

  return {
    activeState,
    isOperational,
    isRunning,
    activeMode: modeFromRest,
  };
};
